import * as React from 'react';

import { extractNicknameFromSlug } from './utils/nickname';

import {
  WelcomeRoot,
  WelcomeTitle,
  WelcomeNick,
  WelcomeInput,
  WelcomeBtn,
  WelcomeHint,
} from './welcome-page.styled';
import { VSpace } from './first-principles.styled';

type Props = {
  placeholder: string | undefined;
  invitationCode: string;
  setInvitationCode: (v: string) => void;
  error: string | null;
  loading: boolean;
  onVerify: (code: string) => Promise<void> | void;
};

export const FpWelcomePage: React.FC<Props> = ({
  placeholder,
  invitationCode,
  setInvitationCode,
  error,
  loading,
  onVerify,
}) => {
  const nickname = React.useMemo(() => extractNicknameFromSlug(placeholder), [placeholder]);

  React.useEffect(() => {
    const bg = '#1A1A1C';

    document.documentElement.style.background = bg;
    document.body.style.background = bg;

    (document.documentElement.style as any).overscrollBehavior = 'none';
    (document.body.style as any).overscrollBehavior = 'none';

    const upsert = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    upsert('theme-color', bg);
    upsert('color-scheme', 'dark');
  }, []);

  return (
    <WelcomeRoot>
      <VSpace $h={96} $hMobile={64} />

      <WelcomeTitle>First Principles</WelcomeTitle>

      <WelcomeNick>Welcome, {nickname}</WelcomeNick>

      <WelcomeInput
        value={invitationCode}
        onChange={(e) => setInvitationCode(e.target.value)}
        placeholder="Enter your invitation code"
        inputMode="text"
        autoComplete="one-time-code"
      />

      {error ? <div>{error}</div> : null}

      <WelcomeBtn type="button" onClick={() => void onVerify(invitationCode)} disabled={loading}>
        {loading ? 'Loading\u2026' : 'Verify Code'}
      </WelcomeBtn>

      <WelcomeHint>
        What follows will take approximately 20 minutes.
        <br />
        Find a quiet space. This works best when you're not rushed.
      </WelcomeHint>
    </WelcomeRoot>
  );
};
